import { render, staticRenderFns } from "./GradeSummaryBarGraphCard.vue?vue&type=template&id=0d4ab00b&"
import script from "./GradeSummaryBarGraphCard.vue?vue&type=script&lang=js&"
export * from "./GradeSummaryBarGraphCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports